import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import Cookies from "js-cookie";
import "./cookiebanner.css";

/* global gtag */

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Visa banner endast om användaren inte redan har gett samtycke
    const hasConsent = Cookies.get("analytics-consent") === "true";
    const hasDeclined = Cookies.get("analytics-consent") === "false";
    
    // Om varken accepterat eller nekat, visa bannern
    if (!hasConsent && !hasDeclined) {
      // Fördröjd visning för bättre Lighthouse-poäng
      setTimeout(() => {
        setIsVisible(true);
      }, 500);
    }
    
    // Kontrollera om GA cookies finns trots att inget samtycke getts
    const hasGACookies = document.cookie.indexOf('_ga=') !== -1;
    if (hasGACookies && !hasConsent) {
      // Radera _ga cookies
      document.cookie = '_ga=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = '_ga_XNRVMGL7MQ=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }, []);

    const acceptCookies = () => {
        Cookies.set("analytics-consent", "true", { expires: 365 });
        setIsVisible(false);
        
        // Ladda Google Analytics manuellt endast vid samtycke
        if (typeof window !== "undefined" && !window.gtagInitialized) {
            window.gtagInitialized = true;
            
            const script = document.createElement("script");
            script.src = `https://www.googletagmanager.com/gtag/js?id=GTM-TZJBW34N`;
            script.async = true;
            script.setAttribute('importance', 'low'); // Låg prioritet för bättre Lighthouse
            document.body.appendChild(script);
            
            window.dataLayer = window.dataLayer || [];
            window.gtag = function() { window.dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'GTM-TZJBW34N', {
            anonymize_ip: true,
            cookie_expires: 0
            });
        }
    };

  const declineCookies = () => {
    Cookies.set("analytics-consent", "false", { expires: 365 });
    setIsVisible(false);
    
    // Avaktivera tracking och ta bort cookies
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied"
      });
    }
    
    // Ta bort eventuella GA cookies
    document.cookie = '_ga=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = '_ga_XNRVMGL7MQ=; Path=/; Domain=.namndatabasen.se; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          Vi använder cookies för att räkna besökare och förbättra din upplevelse.{" "}
          <Link to="/cookies" className="learn-more">
            Läs mer om våra cookies
          </Link>
        </p>
        <div className="button-container">
          <button onClick={declineCookies} className="decline-button">
            Avböj
          </button>
          <button onClick={acceptCookies} className="accept-button">
            Godkänn
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;